import PropTypes from 'prop-types'

const Stepper = ({ currentStep, steps }) => {
  const renderStep = (step, index) => {
    let className = ''
    if (((currentStep !== 0) === currentStep || !!currentStep) && index <= currentStep) {
      className = 'active'
      if (index !== 0 && steps.length - 1 !== currentStep && currentStep === index) {
        className += '__md'
      }
    }

    return (
      <div key={`step_${step}`} className={className}>
        <div className={`step ${index <= currentStep ? 'active' : ''}`} />
        <div className="step-description">{step}</div>
      </div>
    )
  }

  return (
    <div className="stepper">
      <div className="stepper__wrapper">{steps.map(renderStep)}</div>
    </div>
  )
}

Stepper.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.array,
}

export default Stepper
